<script setup>
  defineOptions({name: "ComponentPatientSidebarPatientAddressAttribute"});

  defineProps({
    attribute: {
      type: Object,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  });
</script>

<template>
  <div :class="{'flex flex-wrap space-x-1.5': inline}">
    <h6 class="text-gray-600" :class="{'font-semibold': inline, 'text-xs uppercase': !inline}">
      Patientenanschrift{{ inline ? ":" : "" }}
      <slot name="label" />
    </h6>

    <div :class="{'mt-0.5 text-sm': !inline, 'flex flex-wrap space-x-1.5': inline}">
      <slot>
        <template v-if="patient.is_fake">
          <div class="text-gray-600" :class="{'text-xs': !inline}">
            Die Anschrift wird bei geteilten Patienten nicht übermittelt.
          </div>
        </template>

        <div :data-encrypted="attribute.payload?.supplement" />
        <div :data-encrypted="attribute.payload?.street" />
        <div>
          <span :data-encrypted="attribute.payload?.zip" />
          <span :data-encrypted="attribute.payload?.city" />
        </div>

        <div>
          <span v-if="attribute.payload?.email">
            <span class="text-gray-500">E-Mail:</span>
            <span :data-encrypted="attribute.payload?.email" />
          </span>

          <span v-if="attribute.payload?.telephone">
            <span class="text-gray-500">Tel:</span>
            <span :data-encrypted="attribute.payload?.telephone" />
          </span>
        </div>
      </slot>
    </div>
  </div>
</template>
